import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import translate from '@/api/translate';

export default /*#__PURE__*/_defineComponent({
  __name: 'CancelBtn',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const close = () => {
	emits("change");
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "cancel-btn",
      onClick: close
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(translate).ShowText('取消')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})